export default __webpack_public_path__ + "static/media/GoogleLogo.45446013.svg";